import {DesignSystemExportFnOutput} from '../../_interfaces/designSystem';

export default (prefix: string, datas: object): DesignSystemExportFnOutput => {

  // Placeholders
  const placeholders: DesignSystemExportFnOutput = {};

  for (const [name, value] of Object.entries(datas)) {

    const placeholderPrefix = `${prefix}-${name}`;
    placeholders[`%${placeholderPrefix}-transition`] = {
      sassdoc: {
        '': `Extend design system [${prefix} : ${name}]`,
        '@name': `${placeholderPrefix}-transition`
      },
      css: {
        'transition-duration': `${value}ms`
      }
    };

    placeholders[`%${placeholderPrefix}-animation`] = {
      sassdoc: {
        '': `Extend design system [${prefix} : ${name}]`,
        '@name': `${placeholderPrefix}-animation`
      },
      css: {
        'animation-duration': `${value}ms`
      }
    };
  }

  return placeholders;
};
